import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { EBillDisputeActions, fromEBillDispute } from '@ruby/modules/ebill/store/ebill-dispute.index';
import { selectBillDisputeWithContactState } from '@ruby/modules/ebill/store/selectors/ebill-dispute.selectors';
import { ITransaction } from '@ruby/shared/models/commons/transaction.interface';
import { IEBillDispute } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-dispute-container',
  template: `
    <ng-ebill-dispute *ngIf="(store$ | async) as store"
                      [data]="disputes"
                      [isDisputeDisabled]="store.state.isDisputeDisabled"
                      [loading]="store.state.loading"
                      (disputeBill)="dispatchDisputeBill($event)"
                      (resetHeader)="dispatchResetHeaderCheck()"
    >
    </ng-ebill-dispute>
  `
})
export class EBillDisputeContainer implements OnDestroy {
  store$: Observable<{ state: fromEBillDispute.State; userRacf?: string; email?: string }>;
  billType!: string;
  userRacf?: string;
  email?: string;
  disputes: Array<IEBillDispute> = [];
  private acrSubscription!: Subscription;

  constructor(private store: Store<fromEBillDispute.State>, private acr: ActivatedRoute) {
    this.store$ = store.select(selectBillDisputeWithContactState).pipe(tap((st: { state: fromEBillDispute.State; userRacf?: string; email?: string }) => {
      this.email = st.email;
      this.userRacf = st.userRacf;
    }));
    this.parseTransaction();
  }

  ngOnDestroy(): void {
    this.acrSubscription.unsubscribe();
  }

  /**
   * dispatch Dispute Bill
   *
   * @summary dispatch Dispute Bills
   * @param $event: Array<IEBillDispute>
   * @returns void
   */
  dispatchDisputeBill($event: Array<IEBillDispute>): void {
    this.store.dispatch(EBillDisputeActions.disputeBill({ data: { disputeBills: $event, email: this.email, userRacf: this.userRacf } }));
  }

  /**
   * dispatch Reset Header Check
   *
   * @summary dispatch Reset Header Check
   * @returns void
   */
  dispatchResetHeaderCheck(): void {
    this.store.dispatch(EBillDisputeActions.resetHeaderCheck());
  }

  private load(billType: string): void {
    this.store.dispatch(EBillDisputeActions.loadReasons({ data: billType }));
  }

  private parseTransaction(): void {
    this.acrSubscription = this.acr.data.pipe(
      map((data: Data) => data.transaction)
    ).subscribe((transaction: ITransaction) => {
      if (transaction) {
        const data: { bills: Array<IEBillDispute>; type: string } = JSON.parse(transaction.parameters.eBill!) as { bills: Array<IEBillDispute>; type: string };
        this.load(data.type);
        this.disputes = data.bills;
      }
    });
  }
}
